import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function TermsAndConditions() {
  const lastUpdated = "April 7, 2026";

  const termsContent = [
    {
      id: "1",
      title: "1. Service",
      content: (
        <>
          <p>
            The Site and the Service, including all features and functionalities, instant streaming, our website and user interfaces, and all content and software associated therewith (the "service") are offered under these Terms of Use (the "Terms") together with the other agreements and documents referenced herein, including any future amendments to any of the foregoing (collectively, the "Agreement").
          </p>
          <p>
            By using the Site and/or the Service, either as a Member User, a recipient of an e-mail from a registered user, or as a visitor ("you" or "your"), you agree that the Agreement is a binding contract between you and the merchant. If you do not wish to be bound to these Terms, then immediately stop using the Site and the Service.
          </p>
        </>
      )
    },
    {
      id: "2",
      title: "2. The Agreement",
      content: (
        <>
          <p>You agree that no contract or agreement is formed and you have no rights to the Service, unless and until the merchant has agreed to provide you the Service.</p>
          <p>The merchant may amend or modify the Agreement at any time, without prior notice. The changes become effective immediately upon posting such amended or modified terms on the Site or if the merchant otherwise notifies you of such amended or modified terms. If you use the Site and/or the Service after such notice, you accept the Agreement as amended.</p>
          <p>We may refuse any application to use the Services for any reason whatsoever.</p>
          <p>To use our Services, you are required to create an account with us. In order to create an account, we require you to provide information about yourself: your email address, a password, as well as your name, surname and IBAN or credit/debit card details.</p>
          <p>You agree that we may send communications to your email address for customer service, confirmations, newsletters, product offers and other matters.</p>
        </>
      )
    },
    {
      id: "3",
      title: "3. Your License",
      content: (
        <>
          <p>The merchant grants you a non-exclusive limited license to use the Services, including accessing and viewing the Content on a streaming-only basis through the Site, for personal, non-commercial purposes.</p>
          <p>You may only access and view the Content personally and for a non-commercial purpose in compliance with these Terms. You may not circumvent copyright, DRM, or other protection measures, nor may you reproduce, distribute, broadcast, modify, or exploit the Content without express written permission from the merchant.</p>
          <p>The availability and quality of the Content may vary depending on your location, device, and internet connection. The merchant makes no guarantees about quality or uninterrupted access.</p>
          <p>You may only access the Content in geographic locations where the merchant offers its service and has licensed Content.</p>
        </>
      )
    },
    {
      id: "4",
      title: "4. Support Services",
      content: "Support includes reasonable assistance during regular business hours, updates, and revisions to the Site and Services as the merchant elects to provide."
    },
    {
      id: "5",
      title: "5. Fees and Payment",
      content: (
        <>
          <p>By registering, you may be offered a trial for a small verification fee. If you cancel within the trial period, only the verification fee will be charged. Otherwise, your membership will automatically extend to a monthly plan.</p>
          <p>Membership fees will be billed to your chosen payment method each month unless you cancel. Prices and charges are subject to change with notice.</p>
          <p>Payments are fully earned upon receipt and may not be refunded, except at the sole discretion of the merchant.</p>
          <p>You are responsible for internet access costs.</p>
        </>
      )
    },
    {
      id: "6",
      title: "6. Cancellation",
      content: (
        <>
          <p>You may cancel your membership at any time and will continue to have access until the end of your billing period. Payments are non-refundable, and no refunds will be given for partial months or unused content.</p>
          <p>The merchant may issue refunds or credits at its sole discretion, but such decisions do not entitle you to future credits.</p>
        </>
      )
    },
    {
      id: "7",
      title: "7. Right to Terminate",
      content: "The merchant reserves the right to terminate or restrict your use of the service, without notice, for any reason."
    },
    {
      id: "8",
      title: "8. Your Responsibilities",
      content: (
        <>
          <p>You must use the Services for lawful, non-commercial purposes only. You may not:</p>
          <ul className="pl-6 space-y-2 list-disc">
            <li>Violate intellectual property rights.</li>
            <li>Use unauthorized automated tools to access the Services.</li>
            <li>Introduce malware or harmful code.</li>
            <li>Circumvent security features.</li>
            <li>Interfere with other users' enjoyment of the Services.</li>
          </ul>
        </>
      )
    },
    {
      id: "9",
      title: "9. Suspension/Discontinuation",
      content: "The merchant may change, suspend, or discontinue the Services at any time without notice and without liability."
    },
    {
      id: "10",
      title: "10. Copyright",
      content: "All Content is owned by the merchant or its licensors. You may not reproduce, distribute, or exploit it without permission."
    },
    {
      id: "11",
      title: "11. Links to Other Websites",
      content: "The Site may contain links to third-party websites. The merchant is not responsible for the content or practices of such websites."
    },
    {
      id: "12",
      title: "12. Trademarks",
      content: "All trademarks, logos, and product names are the property of the merchant or their respective owners."
    },
    {
      id: "13",
      title: "13. Force Majeure",
      content: "The merchant is not liable for delays or failures caused by events beyond its reasonable control, such as natural disasters, strikes, or internet outages."
    },
    {
      id: "14",
      title: "14. Disclaimer of Warranties",
      content: "The Service is provided \"as is\" without warranties of any kind, express or implied. You use the Site and Service at your own risk."
    },
    {
      id: "15",
      title: "15. Age Restriction",
      content: "By using this website, you confirm that you are at least 18 years old. Persons under 18 are not permitted to use the Services."
    },
    {
      id: "16",
      title: "16. General Provisions",
      content: (
        <>
          <ul className="space-y-4">
            <li><strong className="text-white">Indemnification:</strong> You agree to indemnify the merchant against claims arising from your use of the Services.</li>
            <li><strong className="text-white">Severability:</strong> If any provision is held invalid, the remainder remains in effect.</li>
            <li><strong className="text-white">No Waiver:</strong> Failure to enforce any provision is not a waiver of rights.</li>
            <li><strong className="text-white">Assignment:</strong> You may not assign rights or obligations under these Terms.</li>
            <li><strong className="text-white">Entire Agreement:</strong> These Terms constitute the full agreement between you and the merchant.</li>
          </ul>
          <p>This agreement shall be governed by and construed in accordance with the laws of Cyprus.</p>
        </>
      )
    }
  ];

  return (
    <div className="flex flex-col min-h-screen font-sans text-white bg-[#0F172A]  relative ">

      {/* GLOBAL BACKGROUND GLOWS */}
      <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1612550761236-e813928f7271?auto=format&fit=crop&q=80&w=2400"
          alt="Background"
          className="w-full h-full object-cover opacity-[0.03] mix-blend-screen"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0F172A]/80 via-[#0F172A]/95 to-[#0F172A]" />

        {/* Soft Theme Glows */}
        <div className="absolute top-0 right-1/4 w-[600px] h-[600px] bg-[#2563EB]/10 rounded-full blur-[150px]" />
        <div className="absolute bottom-1/4 left-1/4 w-[500px] h-[500px] bg-[#F43F5E]/10 rounded-full blur-[150px]" />
      </div>

      {/* HEADER */}
      <div className="relative z-50">
        <Header />
      </div>

      {/* MAIN CONTENT AREA */}
      <main className="flex-1 w-full max-w-5xl mx-auto px-4  pt-40 pb-16  relative z-10 py-16 md:py-24 md:pt-40">

        {/* The Glassmorphism Document Card */}
        <div className="w-full bg-[#1E293B]/80 backdrop-blur-2xl rounded-[2.5rem] border border-slate-700/80 shadow-[0_0_50px_rgba(0,0,0,0.3)] overflow-hidden relative">

          {/* Top highlight bar */}
          <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-[#2563EB] via-purple-500 to-[#F43F5E] opacity-80" />

          {/* Document Header */}
          <div className="px-8 pt-16 pb-8 md:px-16 md:pt-20 md:pb-12 border-b border-slate-700/80">
            <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight text-white mb-4">
              Terms and <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#2563EB] to-[#F43F5E]">Conditions</span>
            </h1>
            <p className="text-slate-400 font-medium">
              Last Updated: <span className="text-[#2563EB]">{lastUpdated}</span>
            </p>
          </div>

          {/* Document Body */}
          <div className="px-8 py-12 md:px-16 md:py-16 space-y-12">

            {/* Introduction block */}
            <div className="space-y-4">
              <p className="font-bold text-white text-lg">Terms of Use</p>
              <p className="text-slate-300 leading-relaxed text-lg">
                Thank you for using our product. The Service is provided by the merchant. By using our Services, you are agreeing to these terms.
              </p>
              <p className="font-bold text-white text-lg mt-6">Dispute Resolution and Governing Law</p>
              <p className="text-slate-300 leading-relaxed text-lg">
                These Terms and Conditions of Use shall be governed by, and interpreted and enforced in accordance with, the laws of Cyprus applicable therein. Any claim, dispute or controversy shall be brought before the competent courts of Cyprus, and the parties attorney to the jurisdiction of such courts. This provision shall survive the termination of your right to use this Site.
              </p>
            </div>

            {/* Render all sections from the array */}
            {termsContent.map((section) => (
              <section key={section.id} className="space-y-4 scroll-mt-24" id={`section-${section.id}`}>
                <h2 className="text-2xl font-bold text-white tracking-tight flex items-center gap-3">
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#2563EB] to-[#F43F5E]">
                    {section.title.split('.')[0]}.
                  </span>
                  {section.title.split('.').slice(1).join('.').trim()}
                </h2>
                <div className="text-slate-300 leading-relaxed space-y-4">
                  {section.content}
                </div>
              </section>
            ))}

          </div>

        </div>

      </main>

      {/* FOOTER */}
      <div className="relative mt-auto">
        <Footer />
      </div>
    </div>
  );
}
